var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMenuAllCalendars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9593 10.2923C13.5757 9.68047 14.0516 9.07241 14.3626 8.63634C14.5653 8.35214 14.6666 8.21001 14.6666 7.99967C14.6666 7.78934 14.5653 7.64721 14.3626 7.36301C13.4519 6.08597 11.1261 3.33301 7.99992 3.33301C7.39472 3.33301 6.81952 3.43618 6.27877 3.61185M4.4982 4.49795C3.15404 5.40447 2.16135 6.62811 1.63728 7.36301C1.43459 7.64721 1.33325 7.78934 1.33325 7.99967C1.33325 8.21001 1.43459 8.35214 1.63728 8.63634C2.54799 9.91341 4.87377 12.6663 7.99992 12.6663C9.32712 12.6663 10.51 12.1701 11.5017 11.5014",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9593 10.2923C13.5757 9.68047 14.0516 9.07241 14.3626 8.63634C14.5653 8.35214 14.6666 8.21001 14.6666 7.99967C14.6666 7.78934 14.5653 7.64721 14.3626 7.36301C13.4519 6.08597 11.1261 3.33301 7.99992 3.33301C7.39472 3.33301 6.81952 3.43618 6.27877 3.61185M4.4982 4.49795C3.15404 5.40447 2.16135 6.62811 1.63728 7.36301C1.43459 7.64721 1.33325 7.78934 1.33325 7.99967C1.33325 8.21001 1.43459 8.35214 1.63728 8.63634C2.54799 9.91341 4.87377 12.6663 7.99992 12.6663C9.32712 12.6663 10.51 12.1701 11.5017 11.5014",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57191 6.66699C6.21855 7.02033 6 7.50853 6 8.04773C6 9.12613 6.8742 10.0003 7.9526 10.0003C8.4918 10.0003 8.98 9.78179 9.33333 9.42839",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57191 6.66699C6.21855 7.02033 6 7.50853 6 8.04773C6 9.12613 6.8742 10.0003 7.9526 10.0003C8.4918 10.0003 8.98 9.78179 9.33333 9.42839",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuAllCalendars);
export default __webpack_public_path__ + "static/media/group_menu_all_calendars.c01ecc6d1c516be89dbf7a5740ec890a.svg";
export { ForwardRef as ReactComponent };